module.exports = __webpack_public_path__ + "img/GR040.469e3a3e.png";